import { unwrapParagraph } from "@productlane/lib/src/tiptap/extensions/mintlify/layout-props"
import {
	readTileColumns,
	TILE_BLOCK,
	TILE_COLUMNS_BLOCK,
	tileGroupHtml,
	tilesFrom,
} from "@productlane/lib/src/tiptap/extensions/mintlify/tile-html"

import type { MdxBlockReader } from "./registry"

const parsers = (parseBody: (markdown: string) => string) => ({
	inline: (markdown: string) => unwrapParagraph(parseBody(markdown)),
	block: parseBody,
})

// Columns first: a lone-tile pass over the same text would split the grid.
export const tileReaders: MdxBlockReader[] = [
	{
		name: "tile-columns",
		pattern: new RegExp(TILE_COLUMNS_BLOCK.source, "g"),
		render: (match, parseBody) =>
			tileGroupHtml(
				tilesFrom(match[2] ?? "", parsers(parseBody)),
				readTileColumns(match[1] ?? ""),
			),
	},
	{
		name: "tile",
		pattern: new RegExp(TILE_BLOCK.source, "g"),
		render: (match, parseBody) =>
			tileGroupHtml(tilesFrom(match[0], parsers(parseBody)), 1),
	},
]
